import { render, staticRenderFns } from "./TranscriptionConfig.vue?vue&type=template&id=26eec850&scoped=true&"
import script from "./TranscriptionConfig.vue?vue&type=script&lang=js&"
export * from "./TranscriptionConfig.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptionConfig.vue?vue&type=style&index=0&id=26eec850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eec850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VSimpleTable,VSpacer})
